<script>
import CustomSeatSpecs from './specs.vue'
export default {
  name: 'view-custom-seat',
  props: {
    value: { type: Object, default: () => {} }
  },
  components: {
    CustomSeatSpecs
  },
  data () {
    return {
      specs: {
        foam_type: null,
        model_type: null,
        offset_3d: null,
        inclination: null,
        inclination_custom: null,
        max_foam_width: null,
        symmetrization: null,
        max_foam_enabled: null,
        other_model_type: null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...v }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <template v-if="specs.is_remill">
        <h6 class="mt-4">{{ $t('Remill of Previous Order') }}</h6>

        <p class="p-0 m-0 mb-2">
          <i class="text-muted mr-2">{{ $t(`Reference`) }}: </i>
          {{ specs.last_reference }}
        </p>
        <p class="p-0 m-0 mb-2">
          <i class="text-muted mr-2">{{ $t(`Order Date`) }}: </i>
          {{ specs.last_order_date | moment('DD/MM/YYYY ') }}
        </p>

        <p class="p-0 m-0 mb-2">
          <i class="text-muted mr-2">{{ $t(`attribute.foam_type.key`) }}: </i>
          <template v-if="specs.last_foam_type === 'mix'">
            <span class="mr-3">{{ $t('attribute.foam_type.mix') }}</span>

            <strong class="text-uppercase mr-2">{{ $t('Seat:') }}</strong>
            {{
              $t(`attribute.foam_type.value`, {
                value: $t(
                  `attribute.foam_type.${specs.last_mix_seat_foam_type}`
                )
              })
            }}

            <strong class="text-uppercase ml-4 mr-2">{{ $t('Back:') }} </strong>
            {{
              $t(`attribute.foam_type.value`, {
                value: $t(
                  `attribute.foam_type.${specs.last_mix_back_foam_type}`
                )
              })
            }}
          </template>
          <template v-else>
            {{
              $t(`attribute.foam_type.value`, {
                value: $t(`attribute.foam_type.${specs.last_foam_type}`)
              })
            }}
          </template>
        </p>
      </template>

      <div class="d-flex flex-column justify-content-start">
        <div class="mr-4">
          <h6 class="mt-4">{{ $t('specifications') }}</h6>
          <custom-seat-specs :specs="specs"></custom-seat-specs>
        </div>

        <div v-if="specs.old_form_data">
          <h6 class="mt-4">{{ $t('Previous Specifications') }}</h6>
          <custom-seat-specs :specs="specs.old_form_data"></custom-seat-specs>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
